// extracted by mini-css-extract-plugin
export default {"appointmentsContainer":"Appointments_appointmentsContainer__y6-3b","filters":"Appointments_filters__uKTnX","details":"Appointments_details__TMdvt"};